import { render } from "./ProductItem.vue?vue&type=template&id=3fffb780&scoped=true&ts=true"
import script from "./ProductItem.vue?vue&type=script&lang=ts"
export * from "./ProductItem.vue?vue&type=script&lang=ts"

import "./ProductItem.vue?vue&type=style&index=0&id=3fffb780&scoped=true&lang=css"

import exportComponent from "C:\\htdocs\\sputnik\\vue\\verdura-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fffb780"]])

export default __exports__